import styled from 'styled-components';

export const Container = styled.div`
  max-width: 680px;
  width: 100%;
`;

export const WrenchImg = styled.img`
  position: absolute;
  top: -51px;
  left: -56px;
  font-variant: common-ligatures;
  z-index: 5;
`;

export const IdeaImg = styled.img`
  position: absolute;
  top: -67px;
  left: 200px;
`;
